export default __webpack_public_path__ + "static/media/boron.7f84b1d4.png";